(function () {
  function stripPageForOutOfStock() {
    var params = new URLSearchParams(window.location.search);
    var availability = params.getAll('filter.v.availability');
    var page = params.get('page');
    if (!page || page === '1') return;
    if (availability.length !== 1 || availability[0] !== '0') return;
    params.delete('page');
    var query = params.toString();
    window.location.replace(window.location.pathname + (query ? '?' + query : ''));
  }

  function updateLabelFromSource(input, sourceInput) {
    if (!input || !sourceInput) return;
    var label = input.closest('label');
    var sourceLabel = sourceInput.closest('label');
    if (!label || !sourceLabel) return;

    var text = label.querySelector('.facet-checkbox__text');
    var sourceText = sourceLabel.querySelector('.facet-checkbox__text');
    if (text && sourceText) text.innerHTML = sourceText.innerHTML;

    var hidden = label.querySelector('.visually-hidden');
    var sourceHidden = sourceLabel.querySelector('.visually-hidden');
    if (hidden && sourceHidden) hidden.innerHTML = sourceHidden.innerHTML;
  }

  function hydrateAvailabilityCounts() {
    var root = document.getElementById('main-collection-filters');
    if (!root || root.getAttribute('data-uc-avail-ready') === 'true') return;

    var sectionId = root.getAttribute('data-id');
    if (!sectionId) return;

    var url = new URL(window.location.href);
    url.searchParams.delete('page');
    url.searchParams.set('section_id', sectionId);

    fetch(url.toString())
      .then(function (response) {
        if (!response.ok) throw new Error('avail counts fetch failed');
        return response.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var sourceInputs = doc.querySelectorAll('#FacetFiltersForm input[name="filter.v.availability"]');
        if (!sourceInputs.length) return;

        document
          .querySelectorAll(
            '#FacetFiltersForm input[name="filter.v.availability"], #FacetFiltersFormMobile input[name="filter.v.availability"]'
          )
          .forEach(function (input) {
            var match = doc.querySelector(
              '#FacetFiltersForm input[name="filter.v.availability"][value="' + input.value + '"]'
            );
            updateLabelFromSource(input, match);
          });

        root.setAttribute('data-uc-avail-ready', 'true');
      })
      .catch(function () {});
  }

  stripPageForOutOfStock();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hydrateAvailabilityCounts);
  } else {
    hydrateAvailabilityCounts();
  }

  document.addEventListener('shopify:section:load', hydrateAvailabilityCounts);
})();
